export default {
	featureFlags: {
		VUE_APP_DEMAND_8733_SHOW_ORDER_IMPORT_TIMEOUT_MESSAGE: true
	}
}
